import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import SummaryLine from 'src/components/ui-component/form-component/abschluss-page/SummaryLine';
import { useApplication } from 'src/context/ApplicationContext';
import { KOSTEN_ARTEN } from 'src/lib/constants/constant';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { DisplayDecimal, DisplayEuro } from 'src/utils/formats';

// import schemas
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
const MA_P = MittelabrufSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

const UebersichtBewilligungKreativMA: FC<{}> = () => {
	const { application } = useApplication();

	const summe = useMemo(() => {
		const allKostenPositionen = get(application, MA_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []);

		const summePersonalAusgaben = allKostenPositionen
			.filter(
				(ele: any) =>
					get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Kostenart_Finanzierung.path, '') === KOSTEN_ARTEN.Personalkosten,
			)
			.reduce((acc: number, curr: any) => acc + get(curr, KP_P.Allgemein_Geplante_Gesamtsumme.path, 0), 0);

		const summeSachausgaben = allKostenPositionen
			.filter(
				(ele: any) =>
					get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Kostenart_Finanzierung.path, '') === KOSTEN_ARTEN.Sachkosten,
			)
			.reduce((acc: number, curr: any) => acc + get(curr, KP_P.Allgemein_Geplante_Gesamtsumme.path, 0), 0);

		return {
			[KOSTEN_ARTEN.Personalkosten]: summePersonalAusgaben,
			[KOSTEN_ARTEN.Sachkosten]: summeSachausgaben,
			gesamt: summePersonalAusgaben + summeSachausgaben,
		};
	}, [application]);

	const verfuegbareZuwendung = useMemo(() => {
		const bewilligteZuwendung = get(application, MA_P.Foerderantrag.schema.attributes.Bewilligung_Bewilligte_Zuwendung.path, 0);
		const bereitAbgerufeneZuwendung = get(application, MA_P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path, 0);

		return Math.max(0, bewilligteZuwendung - bereitAbgerufeneZuwendung);
	}, [application]);

	return (
		<>
			<ApplicationHeading title={'Übersicht Bewilligung'} />
			<Typography>Folgende Projektdaten sind lt. Bescheid bewilligt und zu berücksichtigen:</Typography>

			<Box sx={{ mt: '2rem' }}>
				<SummaryLine
					label={'Zuwendungsfähige Gesamtausgaben bis zu:'}
					alignValueRight
					boldLabel={true}
					value={DisplayEuro(get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Geplante_Projektausgaben.path, 0))}
				/>

				<Typography sx={{ paddingLeft: '0.5rem', mt: '1rem' }}>davon</Typography>

				<SummaryLine
					alignValueRight
					labelPadding='0.75rem 2rem'
					label={'Personalausgaben bis zu:'}
					value={DisplayEuro(summe[KOSTEN_ARTEN.Personalkosten])}
					valueFontWeight={400}
				/>
				<SummaryLine
					alignValueRight
					labelPadding='0.75rem 2rem'
					label={'Sachausgaben bis zu:'}
					value={DisplayEuro(summe[KOSTEN_ARTEN.Sachkosten])}
					valueFontWeight={400}
				/>

				<Box>
					<SummaryLine
						alignValueRight
						labelPadding='0.75rem 2rem'
						label={'Eigenmittel gesamt:'}
						value={DisplayEuro(get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Eingebrachte_Eigen_Und_Drittmittel.path, 0))}
					/>
				</Box>

				<Box sx={{ mt: '2rem' }}>
					<SummaryLine
						alignValueRight
						label={'Förderquote: '}
						boldLabel={true}
						value={DisplayDecimal(get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Foerderquote_Gesamt.path, 0), true)}
					/>
					<SummaryLine
						alignValueRight
						label={'Bewilligte Förderung: '}
						boldLabel={true}
						value={DisplayEuro(get(application, MA_P.Foerderantrag.schema.attributes.Bewilligung_Bewilligte_Zuwendung.path, 0))}
					/>
					<SummaryLine
						alignValueRight
						label={'Noch verfügbare Fördermittel: '}
						value={DisplayEuro(verfuegbareZuwendung)}
						valueFontWeight={400}
					/>
				</Box>
				<Box sx={{ mt: '4rem' }}>
					<Typography>Bitte beachten Sie die Informationen zur Erstellung des Mittelabrufs im Menüpunkt „Wichtige Hinweise“.</Typography>
				</Box>
			</Box>
		</>
	);
};

export default UebersichtBewilligungKreativMA;
